interface DirectAnswerProps {
  /** Paragraphs of the direct answer. Each string renders as its own paragraph. */
  paragraphs: string[];
  title?: string;
  className?: string;
}

/**
 * "In a nutshell" direct-answer box for commercial pages.
 * Mirrors the directAnswer box in GuideLayout so the look is consistent
 * across guides and money pages. Designed to be the first thing a reader
 * (and an AI Overview) sees: a 40-75 word plain-English answer.
 */
const DirectAnswer = ({ paragraphs, title = "In a nutshell", className = "" }: DirectAnswerProps) => {
  return (
    <div className={`bg-white border border-border/30 rounded-2xl px-4 py-3.5 shadow-md shadow-primary/5 ${className}`}>
      <p className="text-sm font-bold text-foreground tracking-tight mb-1.5">💡 {title}</p>
      {paragraphs.map((paragraph, i) => (
        <p key={i} className="text-[0.9rem] leading-[1.65] text-foreground/72 mb-1.5 last:mb-0">
          {paragraph}
        </p>
      ))}
    </div>
  );
};

export default DirectAnswer;
